export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/uncontrollable/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
// module id = 882
// module chunks = 0